import { Mutation, QrCodeVisitStatus } from 'graphql/generated/graphqlTypes';
import { generateMockQrCodeVisitWeb } from 'mocks/graphqlMocks/qrCodeVisitWeb';

export function mockedDeleteQrCodeVisitData(id: string): Pick<Mutation, 'deleteQrCodeVisit'> {
  return {
    deleteQrCodeVisit: generateMockQrCodeVisitWeb({ id, status: QrCodeVisitStatus.Cancelled })
  };
}
